define(
  'searchBoxHandler',[
    'builderShowcaseObserver',
    'event'
  ],
  (builderShowcaseObserver) => {
    'use strict';

    const marketsDropDownList = document.querySelector('[data-component="markets-list"]');

    function SearchBoxHandler() {
    }

    /**
     * @private
     * trackMarketChangedEvent: tracks the event when the marked changed.
     * @param {string} optionSelected market text that was selected.
     */
    function trackMarketChangedEvent(optionSelected) {
      const googleAnalyticsEvent = {
        eventType: 'GA4Event',
        eventName: 'searchterm_events',
        params: {
          click_target: 'BSP about logo search tab',
          search_value: optionSelected
        }
      };

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: {
          data: googleAnalyticsEvent
        }
      }));
    }

    /**
    * @private
    * onMarketChanged: triggers the on change of the markets list
    *
    */
    function onMarketChanged() {
      const selectedOption = marketsDropDownList[marketsDropDownList.selectedIndex];
      const newLatitude = selectedOption.dataset.latitude;
      const newLongitude = selectedOption.dataset.longitude;
      const marketId = selectedOption.dataset.marketId;
      const marketName = selectedOption.dataset.marketName;
      const marketState = selectedOption.dataset.state;
      const zoom = parseInt(selectedOption.dataset.zoomLevel, 10);
      const updatedSearchParams = {
        OriginLat: newLatitude,
        OriginLng: newLongitude,
        MarketId: marketId,
        MarketName: marketName,
        State: marketState,
        Zoom: zoom,
      };
      const selectedMarketOptionText = selectedOption.text;

      trackMarketChangedEvent(selectedMarketOptionText);
      builderShowcaseObserver.setParameters(updatedSearchParams);
      builderShowcaseObserver.commit();
      const state = builderShowcaseObserver.getState();
      state.proposedMarket = state.locations.Markets.find((x) => x.Id === selectedOption.dataset.marketId);
      builderShowcaseObserver.setData(state);
      builderShowcaseObserver.commit();
      builderShowcaseObserver.beforeMapResultsLoaded(state);
    }

    /**
    * @private
    * updateMarketBasedOnMap: updates market list with a market near the area of current map
    * @param {object} proposedMarket to be selected.
    *
    */
    function updateMarketBasedOnMap(proposedMarket) {
      let marketToSelect = null;

      if (proposedMarket) {
        const marketOptions = Array.from(marketsDropDownList.options);
        marketToSelect = marketOptions.find((x) => x.dataset.marketId === proposedMarket.Id);
      }

      marketsDropDownList.removeEventListener('change', onMarketChanged);
      marketsDropDownList[marketsDropDownList.selectedIndex].selected = '';
      if (marketToSelect) {
        marketToSelect.selected = 'selected';
      } else {
        marketsDropDownList[0].selected = 'selected';
      }
      marketsDropDownList.addEventListener('change', onMarketChanged);
    }

    /**
    * @public
    * update: function for receiving notifications about state changes
    * @param {object} data information that was changed.
    *
    */
    SearchBoxHandler.update = function updateSearchBoxValue(data) {
      updateMarketBasedOnMap(data.proposedMarket);
    };

    const events = {
      onMarketListChanged: {
        callbacks: [onMarketChanged],
        elements: '[data-component="markets-list"]',
        events: ['change'],
      },
    };

    window.NewHomeSource.Event(events);
    builderShowcaseObserver.subscribe('onBeforeMapResultsLoaded', SearchBoxHandler);
  }
);

